// extracted by mini-css-extract-plugin
module.exports = {"box":"_Header_box_2z6j6","background-image":"_Header_background-image_1M3jJ","title":"_Header_title__ZYPI"};